var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0008 16.0006C28.0008 16.2658 27.8954 16.5201 27.7079 16.7077C27.5204 16.8952 27.266 17.0006 27.0008 17.0006H7.41454L14.7083 24.2931C14.8012 24.386 14.8749 24.4963 14.9252 24.6177C14.9755 24.739 15.0013 24.8692 15.0013 25.0006C15.0013 25.1319 14.9755 25.2621 14.9252 25.3834C14.8749 25.5048 14.8012 25.6151 14.7083 25.7081C14.6154 25.801 14.5051 25.8747 14.3837 25.9249C14.2623 25.9752 14.1322 26.0011 14.0008 26.0011C13.8694 26.0011 13.7393 25.9752 13.6179 25.9249C13.4965 25.8747 13.3862 25.801 13.2933 25.7081L4.29329 16.7081C4.20031 16.6152 4.12655 16.5049 4.07623 16.3835C4.0259 16.2621 4 16.132 4 16.0006C4 15.8691 4.0259 15.739 4.07623 15.6176C4.12655 15.4962 4.20031 15.3859 4.29329 15.2931L13.2933 6.29306C13.4809 6.10542 13.7354 6 14.0008 6C14.2662 6 14.5206 6.10542 14.7083 6.29306C14.8959 6.4807 15.0013 6.73519 15.0013 7.00056C15.0013 7.26592 14.8959 7.52042 14.7083 7.70806L7.41454 15.0006H27.0008C27.266 15.0006 27.5204 15.1059 27.7079 15.2934C27.8954 15.481 28.0008 15.7353 28.0008 16.0006Z",
    fill: "#57606F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.bbeb4212ea70053372a0fc69310b4670.svg";
export { ForwardRef as ReactComponent };